<template>
    <div>
        <breadcrumb :routerList="[{to:'/establish/rebate',title:'合同签订'},{title:'返利合同审核'}]"/>
        <div class="h-piece" style="margin:20px">
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>经销商签订合同</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="ht" ref="ht" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="合同名称" class="h-elformWrap-2" prop="contractBaseId">
                                <el-input v-model="ht.contractName" :v="ht.contractName" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="经销商名称" class="h-elformWrap-2">
                                <el-input v-model="ht.agentName" :v="ht.agentName" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" class="h-elformWrap-2">
                                <el-input v-model="ht.organization"  style="width:3.2rem" readonly>
                                </el-input>
                            </el-form-item>
                            <el-form-item  label="销售区域" class="h-elformWrap-2">
                                <el-input :v="ht.area" v-model="ht.area" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="渠道" class="h-elformWrap-2">
                                <el-input :v="ht.channel" v-model="ht.channel" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item
                                    prop="year"
                                    label="合同有效期"
                                    class="fltimeselect">
                                <el-date-picker
                                        v-model="ht.year"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期" readonly>
                                </el-date-picker>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30 " style="margin: 20px 20px 0 10px;">
                <div class="h-pieceTitle2 message">
                    <h1 class="h1">目标</h1>
                </div>
                <el-table
                        ref="multipleTable"
                        :data="goalList"
                        stripe
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            label="类型"
                            :show-overflow-tooltip="true"
                            width="250">
                        <template scope="scope">
                            <el-select v-model="scope.row.type" placeholder="请选择">
                                <el-option label="月度" value="1">月度</el-option>
                                <el-option label="季度" value="2">季度</el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="month"
                            label="月度/季度"
                            width="250">
                        <template scope="scope">
                            <el-input v-model="scope.row.month" placeholder="请输入"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal"
                            :show-overflow-tooltip="true"
                            label="目标"
                            width="250"
                    >
                        <template scope="scope">
                            <el-input v-model="scope.row.goal" placeholder="请输入"
                                      oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="rebateCoefficient"
                            :show-overflow-tooltip="true"
                            label="返利率(%)"
                            width="250"
                    >
                        <template scope="scope">
                            <el-input v-model="scope.row.rebateCoefficient" placeholder="请输入"
                                      oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="h-table h-mrt30 " style="margin: 20px 20px 0 10px;">
                <div class="h-pieceTitle2 message">
                    <h1 class="h1">退出原因</h1>
                </div>
                <div  class="h-table h-mrt30 bbbb" >
                    <div class="h-pieceTitle2 hang">
                        <el-form :model="ht" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine inputO">
                            <el-form-item label="退出原因" class="h-elformWrap-2 "
                                          style="margin:30px 0 20px 23px">
                                <el-input :v="ht.tuichuYuanyin" v-model="ht.tuichuYuanyin" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <div v-if="zstype" class="h-rowBox" style="margin-top:30px;">
                <div class="h-rowCon">
                    <div class="h-table h-mrt30 " style="margin: 20px 20px 0 10px;">
                        <div class="h-pieceTitle2 message">
                            <h1 class="h1">审批意见</h1>
                        </div>
                        <div  class="h-table h-mrt30 bbbb" >
                            <div class="h-pieceTitle2 hang">
                                <el-form :model="formLabelAlign" label-position="right" :inline="true"
                                         class="demo-ruleForm h-formbLine inputO">
                                    <el-form-item label="审批意见" class="h-elformWrap-2 " :required="flaag"
                                                  style="margin:30px 0 20px 23px">
                                        <el-input v-model="formLabelAlign.checkMsg" placeholder="请输入"
                                                  class="zidaoO"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div></div>
            <div class="h-txtCenter h-mrt60" style="margin-bottom:40px;">
                <div class="apprButton">
                    <el-row>
                        <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="cancel">返回</el-button>
                        <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgred el-button--default" @click="refuse">驳回</el-button>
                        <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="pass">通过</el-button>
                    </el-row>
                </div>
                <el-button v-if="!zstype"  @click="cancel" class="h-btn h-bBtn h-bgwhite">返回</el-button>
                <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
                <el-button v-if="!zstype"
                           size="small" class="h-btn h-bBtn"
                           @click="genzongLiuch">
                    跟踪审批
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                instid:null,
                formLabelAlign:{},
                zstype:false,
                flaag: true,
                showhistory:false,
                //合同名称
                HTName: [],
                //经销商名称
                AgentName: [],
                //表单
                ht: {
                    //有效期
                    year: [],
                },
                spform: {
                    optflag:null,
                    shpyj:null,
                },
                f: {},
                //产品list
                goalList: [],
            }
        },
        mounted() {
            this.query();
        },
        created() {
            this.query();
        },
        methods: {
            genzongLiuch(){
                this.showhistory = true;
            },
            query() {
                if(this.$route.query.taskstatus==0){
                    this.zstype=true;
                }
                this.instid = this.$route.query.instid;
                this.ht.id = this.$route.query.ywid;
                //初始化获取计划数据
                var id=this.$route.query.ywid;
                var plan={"id":id,"planStatus":1};
                if(this.$route.query.taskstatus&&this.$route.query.taskstatus==1) {
                    //代办已审核的查看页
                    plan = {"id": this.$route.query.ywid};
                }
                ss.fanli.selectTarget(this.ht.id).then(rd => {
                    this.ht = rd;
                    this.getOrgName(rd.contractBaseId);
                    this.goalList = rd.goalList;
                    this.ht.year=[];
                    this.ht.year.push(rd.contractStartTime);
                    this.ht.year.push(rd.contractEndTime);
                });
            },
            //经销商名称带出其他信息
            showForm(value) {
                this.AgentName.forEach(elements => {
                    this.ht.agentCode = elements.userCode;
                });
            },
            //展示经销商名称
            showFormList(value) {
                this.f.userName = value;
                ss.UserCare.agentOption(this.f).then(rd => {
                    this.AgentName = rd;
                });
            },
            //通过合同名称带出销售组织
            getOrgName(value) {
                this.HTName.forEach(elements => {
                    if (value == elements.id) {
                        this.ht.contractName = elements.contractName;
                        this.ht.orgCode = this.$getDictName('kkber_value', elements.orgCode);
                        console.log("222222222222222222")
                    }
                });
            },
            //展示合同名称
            showHtName() {
                ss.fanli.showHtName().then(rd => {
                    this.HTName = rd;
                })
            },
            //取消提交
            cancel() {
                this.$router.push("/establish/contractlist");
            },
            //通过按钮
            pass() {
                this.usercheck(5)
            },

            //驳回按钮
            refuse() {
                console.log(this.formLabelAlign.checkMsg,"sss");
                if(!this.formLabelAlign.checkMsg){
                    this.$msg.msge("请填写审批意见");
                }else{
                    this.usercheck(6)
                }
            },
            //返利合同审核
            usercheck(x) {
                this.formLabelAlign.id=this.$route.query.ywid;
                this.formLabelAlign.taskid=this.$route.query.taskid;
                this.formLabelAlign.planStatus=x;
                console.log(this.formLabelAlign,"-------------");
                ss.fanli.checkFanliTuichuContract(this.formLabelAlign).then(rd => {
                    this.$store.dispatch('searchTasktotal');
                    this.$msg.alerts("提交成功！",()=>{
                        this.$router.push({path:'/establish/contractlist'})
                    })
                });
            },
        }
    }
</script>
<style scoped>
    .h-tableInput .el-input {
        height: 100%;
    }

    .anniu {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

</style>
<style>
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.8rem
    }

    .n-two .h-formbLine .el-form-item__label {
        width: 40%;
    }

    .n-two .h-formbLine .el-form-item__content {
        width: 60%;
    }

    .create .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .create .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .fltimeselect .el-date-editor.el-input__inner {
        width: 4rem;
    }

    .fltimeselect .el-form-item__content {
        line-height: 0.2rem;
    }

    .fltimeselect .el-date-editor .el-range-separator {
        width: 12%;
        line-height: 17px;
    }

    .fltimeselect .el-input__inner {
        padding-right: 0.1rem;
    }
</style>
